<template>
  <div class="media-list">
    <breadcrumb main-name="点位管理"
                :breadcrumbList="breadcrumbList"></breadcrumb>
    <div class="readyplay_list">
      <!-- <a-button @click="exportMediaExcel">导出点位</a-button> -->
      <a-dropdown v-if="userInfo.userType != 5 && userInfo.userType != 6">
        <a-menu slot="overlay"
                @click="handleMoreMenu($event)">
          <!-- <a-menu-item key="1" v-if="userInfo.userType == 1"
            >预播设备</a-menu-item
          > -->
          <a-menu-item key="2"
                       v-if="userInfo.userType == 1">变更日志</a-menu-item>
          <a-menu-item key="3"
                       v-if="userInfo.userType == 1">批量修改资源占比</a-menu-item>
          <a-menu-item key="4"
                       v-if="userInfo.userType == 1">广告预播点位</a-menu-item>
          <a-menu-item key="5"
                       v-if="userInfo.userType == 1">导入点位记录</a-menu-item>
          <!-- <a-menu-item key="6" v-if="userInfo.userType == 1"
            >价格设置</a-menu-item
          > -->
        </a-menu>
        <a-button v-if="userInfo.userType == 1">
          更多操作
          <a-icon type="caret-down" />
        </a-button>
      </a-dropdown>
    </div>

    <div style="margin: 24px; background: #fff">
      <div class="select-box">
        <a-row :gutter="[32, 16]"
               type="flex">
          <a-col :xxl="{ span: 6 }"
                 :xl="{ span: 7 }"
                 :lg="{ span: 12 }"
                 :md="{ span: 24 }"
                 :sm="24"
                 class="custom-form-item">
            <a-row type="flex"
                   justify="start"
                   align="middle"
                   class="custom-form-row">
              <span class="form-label">所在区域：</span>
              <MultipleCascder :value="filterParams.city"
                               :allowClear="true"
                               placeholder="请选择所在区域"
                               :selectOptionsConfig="{
                  key: 'value',
                  value: 'value',
                  text: 'label',
                  children: 'children',
                }"
                               allText=""
                               noDataText="暂无数据"
                               :treeData="citySourceArray"
                               @change="changeCity"
                               style="flex: 1"
                               :maxTagCount="2"
                               :maxTagTextLength="5" />
              <!-- <a-cascader
                style="flex: 1"
                :options="citySource"
                v-model="filterParams.city"
                @change="filterCity"
                changeOnSelect
                placeholder="请选择所在区域"
              /> -->
            </a-row>
          </a-col>
          <a-col :xxl="{ span: 6 }"
                 :xl="{ span: 7 }"
                 :lg="{ span: 12 }"
                 :md="{ span: 24 }"
                 :sm="24"
                 justify="start"
                 align="middle"
                 class="custom-form-item">
            <a-row type="flex"
                   justify="start"
                   align="middle"
                   class="custom-form-row">
              <span class="form-label">网点资源：</span>
              <a-input v-model="filterParams.communityName"
                       placeholder="请输入网点名称"
                       allowClear />
            </a-row>
          </a-col>
          <a-col :xxl="{ span: 6 }"
                 :xl="{ span: 7 }"
                 :lg="{ span: 12 }"
                 :md="{ span: 24 }"
                 :sm="24"
                 class="custom-form-item">
            <a-row type="flex"
                   justify="start"
                   align="middle"
                   class="custom-form-row">
              <span class="form-label">点位名称：</span>
              <a-input v-model="filterParams.deviceName"
                       placeholder="请输入点位名称"
                       allowClear />
            </a-row>
          </a-col>
          <a-col v-show="foldForm"
                 :xxl="{ span: 6 }"
                 :xl="{ span: 7 }"
                 :lg="{ span: 12 }"
                 :md="{ span: 24 }"
                 :sm="24"
                 class="custom-form-item">
            <a-row type="flex"
                   justify="start"
                   align="middle"
                   class="custom-form-row">
              <span class="form-label">MAC：</span>
              <a-input v-model="filterParams.MAC"
                       placeholder="请输入MAC"
                       allowClear />
            </a-row>
          </a-col>
          <a-col v-show="foldForm"
                 :xxl="{ span: 6 }"
                 :xl="{ span: 7 }"
                 :lg="{ span: 12 }"
                 :md="{ span: 24 }"
                 :sm="24"
                 class="custom-form-item"
                 :class="{ 'custom-fold': foldForm }">
            <a-row type="flex"
                   justify="start"
                   align="middle"
                   class="custom-form-row">
              <span class="form-label">媒体型号：</span>
              <a-select allowClear
                        style="width: 100%"
                        v-model="filterParams.version"
                        placeholder="请选择媒体型号">
                <a-select-option v-for="item in modelType"
                                 :value="item.text"
                                 :key="item.text">{{ item.text }}</a-select-option>
              </a-select>
            </a-row>
          </a-col>
          <a-col v-show="foldForm"
                 :xxl="{ span: 6 }"
                 :xl="{ span: 7 }"
                 :lg="{ span: 12 }"
                 :md="{ span: 24 }"
                 :sm="24"
                 class="custom-form-item"
                 :class="{ 'custom-fold': foldForm }">
            <a-row type="flex"
                   justify="start"
                   align="middle"
                   class="custom-form-row">
              <span class="form-label">所属公司：</span>
              <a-input v-model="filterParams.companyName"
                       placeholder="请选择所属公司"
                       allowClear />
            </a-row>
          </a-col>
          <a-col v-show="foldForm"
                 :xxl="{ span: 6 }"
                 :xl="{ span: 8 }"
                 :lg="{ span: 12 }"
                 :md="{ span: 24 }"
                 :sm="24"
                 class="custom-form-item"
                 :class="{ 'custom-fold': foldForm }">
            <a-row type="flex"
                   justify="start"
                   align="middle"
                   class="custom-form-row">
              <span class="form-label">监播方式：</span>
              <a-select allowClear
                        mode="multiple"
                        style="width: 100%"
                        v-model="filterParams.watchMode"
                        placeholder="请选择监播方式">
                <a-select-option value="1">程序截屏</a-select-option>
                <a-select-option value="2">人工拍照</a-select-option>
              </a-select>
            </a-row>
          </a-col>
          <a-col v-show="foldForm"
                 :class="{ 'custom-fold': foldForm }"
                 :xxl="{ span: 6 }"
                 :xl="{ span: 8 }"
                 :lg="{ span: 12 }"
                 :md="{ span: 24 }"
                 :sm="24"
                 class="custom-form-item">
            <a-row type="flex"
                   justify="start"
                   align="middle"
                   class="custom-form-row">
              <span class="form-label">连续在线：</span>
              <a-select :value="String(filterParams.thisDate)"
                        style="width: 95%"
                        @change="selectDate">
                <a-select-option v-for="val in daysNumber"
                                 :value="val"
                                 :key="val">{{
                    val == 0 ? '不限' : '大于' + val + '天'
                  }}</a-select-option>
              </a-select>
            </a-row>
          </a-col>
          <a-col v-show="foldForm"
                 class="custom-form-item"
                 :class="{ 'custom-fold': foldForm }"
                 style="flex-grow: 0;"
                 :xxl="{ span: 6 }"
                 :xl="{ span: 8 }"
                 :lg="{ span: 12 }"
                 :md="{ span: 24 }"
                 :sm="24">
            <a-row type="flex"
                   justify="start"
                   align="middle"
                   class="custom-form-row">
              <span class="form-label">标签：</span>
              <MultipleCascder :value="filterParams.tagIds"
                               :allowClear="true"
                               placeholder="请选择标签"
                               :selectOptionsConfig="{
                                  key: 'id',
                                  value: 'id',
                                  text: 'name',
                                  children: 'children',
                                  disabled:'status'
                                }"
                               allText=""
                               noDataText="暂无数据"
                               :treeData="tagsTree"
                               @change="changetags"
                               style="flex: 1"
                               :maxTagCount="1"
                               :maxTagTextLength="5"
                               :compact="true"
                               :modeValue.sync="filterParams.tagReverseFlag" />
            </a-row>
          </a-col>
          <a-col :xxl="{ span: 6 }"
                 :xl="{ span: 7 }"
                 :lg="{ span: 12 }"
                 :md="{ span: 24 }"
                 :sm="24">
            <a-row type="flex"
                   justify="start"
                   align="middle"
                   class="custom-form-row">
              <a-button type="primary"
                        html-type="submit"
                        @click="handleSearch">
                查询
              </a-button>
              <a-button :style="{ marginLeft: '8px' }"
                        @click="handleReset">
                重置
              </a-button>
              <div class="fold-btn"
                   @click="foldClick">
                <span style="margin: 0 4px 0 12px">{{
                  foldForm ? '收起' : '展开'
                }}</span>
                <a-icon type="down"
                        :class="['rotate-icon', { 'rotate-up': foldForm }]" />
              </div>
            </a-row>
          </a-col>

        </a-row>
      </div>
      <a-alert showIcon
               type="info"
               class="media-info-box">
        <template>
          <div slot="message"
               class="media-info-content">
            共&nbsp<span class="meida-box-num">{{ total }}</span>&nbsp个点位
            <div class="meida-box-btn"
                 @click="exportMediaExcel">
              导出当前点位
            </div>
          </div>
        </template>
      </a-alert>
      <div class="table-wrap mediaList_table">
        <a-table :columns="mediaListColumns"
                 :dataSource="mediaList"
                 :pagination="false"
                 :scroll="{ x: 1760 }"
                 @change="columnsFilter">
          <a-icon slot="filterIcon"
                  slot-scope="filtered"
                  type="search"
                  :style="{ color: filtered ? '#108ee9' : undefined }" />
          <template slot="tagCnt"
                    slot-scope="text, record, index">
            <a-button @click="clickTagNum(record, index)"
                      type="link">
              {{ record.tagCnt }}
            </a-button>
          </template>
          <template slot="MAC"
                    slot-scope="row">
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{ row.MAC }}</span>
              </template>
              {{ row.MAC }}
            </a-tooltip>
          </template>
          <template slot="mediaStatus"
                    slot-scope="mediaStatus">
            <span v-if="mediaStatus == 1">
              <a-badge status="success" />设备在线
            </span>
            <span v-else-if="mediaStatus == 0">
              <a-badge status="warning" />设备离线
            </span>
            <span v-else-if="mediaStatus == 2">
              <a-badge status="warning" />离线超时
            </span>
          </template>
          <template slot="sourceStatus"
                    slot-scope="sourceStatus">
            <span v-if="sourceStatus == 2">
              <a-badge status="success" />正常
            </span>
            <span v-else>
              <a-badge status="warning" />异常
            </span>
          </template>
          <template slot="publishStatus"
                    slot-scope="publishStatus">
            <span v-if="publishStatus == '0'">
              <a-badge status="warning" />不接广告
            </span>
            <span v-if="publishStatus == '1'">
              <a-badge status="success" />可接广告
            </span>
            <span v-if="publishStatus == '-1'">
              <a-badge status="warning" />--
            </span>
          </template>
          <template slot="action"
                    slot-scope="action">
            <a-dropdown>
              <a class="ant-dropdown-link"
                 href="javascript:;">
                操作
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay"
                      @click="handleRow($event, action)">
                <a-menu-item v-if="[1, 4, 5, 6].indexOf(userInfo.userType) !== -1"
                             key="7">资源使用情况</a-menu-item>
                <a-menu-item key="4">物料更新记录</a-menu-item>
                <a-menu-item key="5"
                             :disabled="
                    action.publishStatus == 0 && action.sourceStatus != 2
                  ">设置开放情况</a-menu-item>
                <a-menu-item key="6">点位详情</a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
          <template v-for="(item, columnIndex) in ellipsisArr"
                    :slot="item.col"
                    slot-scope="text, record, index">
            <ellipsisTemplate :padding="item.padding"
                              :columnText="text"
                              :width="item.width" />
          </template>
        </a-table>
        <div class="page-wrap">
          <a-pagination :total="total"
                        :pageSize="pageSize"
                        v-model="current"
                        @showSizeChange="onShowSizeChange"
                        @change="changePage">
          </a-pagination>
          <span>共{{ total }}条</span>
        </div>
      </div>
      <!--播放列表-->
      <a-modal class="play-modal"
               title="播放列表"
               v-model="playListModal"
               width="60%">
        <div>
          <div class="radio-wrap">
            <a-radio-group :value="adType"
                           @change="value => chooseAdType(value, 'play')"
                           buttonStyle="solid">
              <a-radio-button value="1">轮播广告</a-radio-button>
              <a-radio-button value="2">精准广告</a-radio-button>
            </a-radio-group>
          </div>
          <a-table :columns="playColumns"
                   :dataSource="playList"
                   :pagination="false">
            <template slot="planName"
                      slot-scope="row">
              <a href="javascript:;"
                 @click="goPlanDetail(row)">{{
                row.planName
              }}</a>
            </template>
            <!--点位要求-->
            <template slot="pointDemand"
                      slot-scope="row">
              <span>{{
                `${row.playDuration || '--'}秒/${row.playTimes || 0}次`
              }}</span>
            </template>
            <template slot="playDuration"
                      slot-scope="row">
              <span>{{ row.playDuration || '' }}</span>
            </template>
            <template slot="action"
                      slot-scope="row">
              <a href="javascript:;"
                 @click="showMaterial(row)">查看物料</a>
            </template>
          </a-table>
          <div class="page-wrap">
            <a-pagination size="small"
                          :total="playTotal"
                          v-model="playPageNum"
                          @change="changePlayPage">
            </a-pagination>
          </div>
        </div>
        <template slot="footer">
          <a-button @click="playListModal = false">关闭</a-button>
        </template>
      </a-modal>
      <!--广告列表-->
      <a-modal class="play-modal"
               :title="
          `广告列表 ${
            currentAdObj.currentDate ? '(' + currentAdObj.currentDate + ')' : ''
          }`
        "
               v-model="adListModal"
               width="60%">
        <div>
          <div class="radio-wrap">
            <a-radio-group :value="dayAdType"
                           @change="value => switchAdType(value, currentAdObj)"
                           buttonStyle="solid">
              <a-radio-button value="1">轮播广告</a-radio-button>
              <a-radio-button value="2">精准广告</a-radio-button>
            </a-radio-group>
          </div>
          <a-table :columns="adColumns"
                   :dataSource="adList"
                   :pagination="false">
            <template slot="planName"
                      slot-scope="row">
              <a href="javascript:;"
                 @click="goPlanDetail(row)">{{
                row.planName
              }}</a>
            </template>
            <template slot="pointDemand"
                      slot-scope="row">
              <span>{{
                `${row.playDuration || '--'}秒/${row.playTimes || 0}次`
              }}</span>
            </template>
            <template slot="action"
                      slot-scope="row">
              <a href="javascript:;"
                 @click="showAdMaterial(row)">查看物料</a>
            </template>
          </a-table>
          <div class="page-wrap">
            <a-pagination size="small"
                          :total="adDayTotal"
                          v-model="adDayPageNum"
                          @change="changeAdPage">
            </a-pagination>
          </div>
        </div>
        <template slot="footer">
          <a-button @click="adListModal = false">关闭</a-button>
        </template>
      </a-modal>
      <!--物料更新记录-->
      <a-modal title="物料更新记录"
               v-model="materialUpdateModal"
               width="50%">
        <a-table :columns="materialColumns"
                 :dataSource="materialList"
                 :pagination="false">
          <template slot="packageVersion"
                    slot-scope="row">
            <a href="javascript:;"
               @click="showPackageList(row)">{{
              row.packageVersion
            }}</a>
          </template>
        </a-table>
        <div class="page-wrap">
          <a-pagination size="small"
                        :total="updateTotal"
                        v-model="updatePageNum"
                        @change="changeUpdatePage">
          </a-pagination>
        </div>
        <template slot="footer">
          <a-button @click="materialUpdateModal = false">关闭</a-button>
        </template>
      </a-modal>
      <!--广告包列表-->
      <a-modal class="play-modal"
               :title="packageList.title"
               v-model="packageModal"
               width="60%">
        <div>
          <div class="radio-wrap">
            <a-radio-group :value="packageList.type"
                           @change="value => chooseAdType(value, 'package')"
                           buttonStyle="solid">
              <a-radio-button value="1">轮播广告</a-radio-button>
              <a-radio-button value="2">精准广告</a-radio-button>
            </a-radio-group>
          </div>
          <a-table :columns="packageList.columns"
                   :dataSource="packageList.list"
                   :pagination="false">
            <template slot="planName"
                      slot-scope="row">
              <a href="javascript:;"
                 @click="goPlanDetail(row)">{{
                row.planName
              }}</a>
            </template>
            <template slot="action"
                      slot-scope="row">
              <a href="javascript:;"
                 @click="showMaterial(row)">查看物料</a>
            </template>
          </a-table>
        </div>
        <template slot="footer">
          <a-button @click="packageModal = false">关闭</a-button>
        </template>
      </a-modal>
      <!--查看物料-->
      <a-modal v-model="materialModal"
               :footer="null"
               width="450px"
               @cancel="handleCancel"
               :z-index="1001">
        <div class="material-box"
             v-if="materialInfo.playType == 2">
          <div v-for="(item, index) in materialInfo.materialDetailsList"
               :key="index"
               class="img-mask"
               :class="item.adSpace == 2 ? 'video-mask' : ''">
            <img v-if="item.fileType == 1"
                 :src="item.fileUrl"
                 alt="" />
            <video v-if="item.fileType == 3"
                   :src="item.fileUrl"
                   autoplay="autoplay"
                   loop="loop"
                   controls></video>
          </div>
        </div>
        <div class="material-box full-screen-mask"
             v-else>
          <div class="img-mask"
               v-if="materialInfo.materialDetailsList.length > 0">
            <img v-if="materialInfo.materialDetailsList[0].fileType == 1"
                 :src="materialInfo.materialDetailsList[0].fileUrl"
                 alt="" />
            <video v-else
                   :src="materialInfo.materialDetailsList[0].fileUrl"
                   autoplay="autoplay"
                   loop="loop"
                   ref="showMaterialVideo"
                   controls></video>
          </div>
        </div>
      </a-modal>
      <!--查看轮播广告物料-->
      <a-modal v-model="adMaterialModal"
               :footer="null"
               width="450px"
               @cancel="adMaterialModal = !adMaterialModal"
               :z-index="1001">
        <div class="material-box full-screen-mask">
          <div class="img-mask">
            <img :src="currentMaterialUrl"
                 alt="" />
          </div>
        </div>
      </a-modal>
    </div>
    <!--媒体更新日志-->
    <a-modal width="65%"
             title="媒体更新日志"
             v-model="isMediaLogListModal">
      <a-table :columns="meidaLogListColumns"
               :dataSource="meidaLogList"
               class="mediaLog_table"
               :pagination="false">
        <span slot="type"
              slot-scope="type">
          {{
            type === 0
              ? '新增'
              : type === 1
              ? '修改'
              : type === 2
              ? '删除'
              : '--'
          }}
        </span>
      </a-table>
      <div class="page-wrap">
        <a-pagination :pageSizeOptions="pageSizeOptions"
                      :total="logPageInfo.pageTotal"
                      showSizeChanger
                      showQuickJumper
                      :pageSize="logPageInfo.pageSize"
                      v-model="logPageInfo.current"
                      @showSizeChange="logOnShowSizeChange"
                      @change="logChangePage">
        </a-pagination>
      </div>
      <template slot="footer">
        <a-button @click="isMediaLogListModal = false">关闭</a-button>
      </template>
    </a-modal>
    <!--批量修改资源占比弹框-->
    <a-modal title="批量修改资源占比"
             v-model="isMediaSourceModal"
             @ok="handleUpload"
             :confirmLoading="false"
             @cancel="cancelCommitExecl">
      <div class="bat-src">
        <a-upload-dragger name="file"
                          :fileList="fileList"
                          :beforeUpload="beforeUploadFun"
                          @change="handleChange">
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">点击或将批量设置文档拖拽到这里上传</p>
          <p class="ant-upload-hint">只限 .xls .xlsx 格式</p>
        </a-upload-dragger>
        <!-- https://yxy-1256017579.cos.ap-guangzhou.myqcloud.com/QFAD/template/%E6%89%B9%E9%87%8F%E7%82%B9%E4%BD%8D%E8%AE%BE%E7%BD%AE%E6%AF%94%E4%BE%8B%E6%A8%A1%E7%89%88.xls -->
        <span class="load-text">
          还没有批量设置模板？<a
             href="https://yxy-1256017579.cos.ap-guangzhou.myqcloud.com/QFAD/template/%E6%89%B9%E9%87%8F%E7%82%B9%E4%BD%8D%E8%AE%BE%E7%BD%AE%E6%AF%94%E4%BE%8B%E6%A8%A1%E7%89%88.xls">点击这里</a>下载
        </span>
      </div>
    </a-modal>
    <!--资源使用情况弹框-->
    <a-modal class="play-modal"
             title="资源使用情况"
             v-model="isUsageModal"
             width="35%">
      <div>
        <a-table :columns="resourceUsageColumns"
                 :dataSource="resourceUsageList"
                 :pagination="false"
                 class="resource-usage">
          <template slot="createTime"
                    slot-scope="date">
            {{ date || '' }}
          </template>
          <template slot="mediaUsage"
                    slot-scope="usePercent">
            <a-progress :percent="usePercent"
                        size="small"
                        status="active" />
          </template>
          <template slot="action"
                    slot-scope="row">
            <a href="javascript:;"
               @click="showOnedayPlayList(row)">广告列表</a>
          </template>
        </a-table>
        <div class="page-wrap">
          <a-pagination size="small"
                        :total="adTotal"
                        v-model="adPageNum"
                        :pageSize="5"
                        @change="changeResourceUsagePage">
          </a-pagination>
        </div>
      </div>
      <template slot="footer">
        <a-button @click="isUsageModal = false">关闭</a-button>
      </template>
    </a-modal>
    <!-- 广告预播点位 -->
    <pre-broadcast-modal :visible="preBroadcast"
                         :requestParams="preBroadcastParams"
                         @operate="showOnedayPlayList"
                         @close="testClose"></pre-broadcast-modal>
    <!-- 导入点位记录 -->
    <update-history-modal :visible="updatePointModal"
                          @close="updatePointModal = false"></update-history-modal>
    <!-- 设置点位状态 -->
    <a-modal title="设置点位状态"
             wrapClassName="switch-status-modal"
             width="260px"
             :visible="switchStatus"
             :confirm-loading="switchStatusLoading"
             :closable="false"
             @ok="switchStatusFun"
             @cancel="switchStatus = false">
      <a-radio-group v-model="statusForm">
        <a-radio :value="1"> 可接广告 </a-radio>
        <a-radio :value="0"> 不接广告 </a-radio>
      </a-radio-group>
    </a-modal>
    <!-- 资源使用情况 -->
    <point-res-usage :visible="pointResUsageModal"
                     :requestParams="{ pointId: this.pointId }"
                     @close="pointResUsageModal = false"></point-res-usage>

    <!-- 点位标签弹出窗 -->
    <PointTagModal v-if="isPointTagModal"
                   :visible.sync="isPointTagModal"
                   :pointTagModalId="pointTagModalId"
                   @changeHandler="getMediaList" />
  </div>
</template>

<script>
// 获取到城市选择
import { getCityListData } from '../../commomFun/public'
import breadcrumb from '../common/Breadcrumb.vue'
import api from '../../commomFun/api.js'
import { config } from '../../utils/config'
import timeFormat from '../../commomFun/timeFormat'
import ellipsisTemplate from '../common/ellipsisTemplate'
import updateHistoryModal from './common/updateHistoryModal.vue'
import preBroadcastModal from './common/preBroadcast.vue'
import PointResUsage from './common/pointResUsage.vue'
import PointTagModal from './PointTagModal'
import MultipleCascder from '../common/MultipleCascder.vue'
export default {
  name: 'HelloWorld',
  components: {
    breadcrumb,
    ellipsisTemplate,
    updateHistoryModal,
    preBroadcastModal,
    PointResUsage,
    PointTagModal,
    MultipleCascder,
  },
  data() {
    return {
      daysNumber: ['0', '3', '7', '15', '30'], //在线天数
      foldForm: false,
      userInfo: '',
      // 面包屑
      breadcrumbList: [
        {
          name: '点位管理',
          path: '/mediaList',
        },
      ],
      // 过滤参数
      filterParams: {
        city: [],
        deviceName: '',
        communityName: '',
        MAC: '',
        version: undefined,
        companyName: '',
        watchMode: [],
        devStatus: null,
        status: null,
        publishStatus: null,
        thisDate: '0',
        tagIds: [],
      },
      // 省市区下拉
      citySource: [],
      // 媒体列表
      mediaList: [],
      pageSizeOptions: ['10', '20', '30', '40'],
      current: 1,
      pageSize: 10,
      total: 0,
      adType: '1',
      // 某天广告列表的类型， 暂时只有轮播广告
      dayAdType: '1',
      // 播放列表
      playListModal: false,
      // 广告列表
      adList: [],
      // 资源使用情况列表
      adTotal: 0,
      adPageNum: 1,
      adListModal: false,
      // 某天广告列表
      adDayTotal: 0,
      adDayPageNum: 1,
      currentAdObj: {},
      playTotal: 0,
      playPageNum: 1,
      ellipsisArr: [
        {
          col: 'province',
          width: '78px',
          padding: 16,
        },
        {
          col: 'city',
          width: '90px',
          padding: 16,
        },
        {
          col: 'area',
          width: '78px',
          padding: 16,
        },
        {
          col: 'communityName',
          width: '150px',
          padding: 16,
        },
        {
          col: 'deviceName',
          width: '150px',
          padding: 16,
        },
        {
          col: 'MAC',
          width: '160px',
          padding: 16,
        },
        {
          col: 'pointId',
          width: '60px',
          padding: 16,
        },
        {
          col: 'TerminalType',
          width: '130px',
          padding: 16,
        },
        {
          col: 'companyName',
          width: '130px',
          padding: 16,
        },
        {
          col: 'watchModeName',
          width: '150px',
          padding: 16,
        },
      ],
      playColumns: [
        {
          title: '计划名称',
          key: 'planName',
          scopedSlots: { customRender: 'planName' },
        },
        {
          title: '开始时间',
          dataIndex: 'beginTime',
          key: 'beginTime',
          width: 200,
        },
        {
          title: '结束时间',
          dataIndex: 'endTime',
          key: 'endTime',
          width: 200,
        },
        {
          title: '点位要求',
          key: 'pointDemand',
          scopedSlots: { customRender: 'pointDemand' },
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      playList: [
        {
          key: '1',
          planName: '',
          beginTime: '',
          endTime: '',
        },
      ],
      adColumns: [
        {
          title: '计划名称',
          key: 'planName',
          scopedSlots: { customRender: 'planName' },
        },
        {
          title: '开始时间',
          dataIndex: 'beginTime',
          key: 'beginTime',
        },
        {
          title: '结束时间',
          dataIndex: 'endTime',
          key: 'endTime',
        },
        {
          title: '点位要求',
          key: 'pointDemand',
          scopedSlots: { customRender: 'pointDemand' },
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 物料更新记录
      materialUpdateModal: false,
      materialModal: false,
      adMaterialModal: false,
      // 广告列表物料
      currentMaterialUrl: '',
      updateTotal: 0,
      updatePageNum: 1,
      materialColumns: [
        {
          dataIndex: 'type',
          title: '类型',
          key: 'type',
        },
        {
          title: '广告包版本',
          key: 'packageVersion',
          scopedSlots: { customRender: 'packageVersion' },
        },
        {
          title: '物料更新时间',
          dataIndex: 'updateTime',
          key: 'updateTime',
        },
      ],
      materialList: [],
      // 查看物料
      materialInfo: {
        playType: 1,
        materialDetailsList: [
          {
            fileType: 1, // 1-图片 3-视频
            fileUrl: '../../../public/images/a-1.png',
            playDuration: '', // 上传物料视频时长
            playForm: '', // 上传物料播放形式
          },
        ],
      },
      previewImgModal: false,
      previewVideoModal: false,
      previewUrl: '',
      pointId: '',
      // 广告包
      packageModal: false,
      packageList: {
        title: '',
        type: '1',
        list: [],
        columns: [
          {
            title: '计划名称',
            key: 'planName',
            scopedSlots: { customRender: 'planName' },
          },
          {
            title: '开始时间',
            dataIndex: 'beginTime',
            key: 'beginTime',
          },
          {
            title: '结束时间',
            dataIndex: 'endTime',
            key: 'endTime',
          },
          {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ],
      },
      // 媒体变更弹出框
      isMediaLogListModal: false,
      // 批量修改资源弹框
      isMediaSourceModal: false,
      // 预播点位弹框
      preBroadcast: false,
      preBroadcastParams: {},
      // 导入（同步点位）弹框
      updatePointModal: false,
      // 资源占比弹框
      isSourcePercentModal: false,
      //设置资源占比确认按钮loading
      percentLoading: false,
      // 资源使用情况弹框
      isUsageModal: false,
      meidaLogListColumns: [
        {
          title: '时间',
          key: 'createTime',
          dataIndex: 'createTime',
          width: 140,
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '媒体',
          key: 'mediaName',
          dataIndex: 'mediaName',
          width: 245,
          scopedSlots: { customRender: 'mediaName' },
        },
        {
          title: '操作',
          key: 'type',
          dataIndex: 'type',
          width: 78,
          scopedSlots: { customRender: 'type' },
        },
        {
          title: '内容',
          key: 'content',
          dataIndex: 'content',
          width: 152,
          scopedSlots: { customRender: 'content' },
        },
      ],
      // 资源使用情况列表
      resourceUsageList: [],
      // 资源使用情况弹框列表
      resourceUsageColumns: [
        {
          title: '日期',
          key: 'date',
          dataIndex: 'date',
          width: 140,
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '使用情况',
          key: 'usePercent',
          dataIndex: 'usePercent',
          width: 245,
          scopedSlots: { customRender: 'mediaUsage' },
        },
        {
          title: '操作',
          key: 'action',
          width: 78,
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 日志表格
      meidaLogList: [],
      // 日志分页
      Log: '',
      logPageInfo: {
        pageTotal: 0,
        pageSize: 10,
        current: 1,
      },
      // 头部自定义过滤
      filteredSelect: {
        sourceStatus: [],
        publishStatus: [],
        mediaStatus: [],
      },
      percentObj: {
        0: '0%',
        10: '5%',
        20: '10%',
        30: '15%',
        35: '20%',
        45: '25%',
        55: '30%',
        60: '35%',
        70: '40%',
        80: '45%',
        90: '50%',
        100: '55%',
        110: '60%',
        115: '65%',
        125: '70%',
        135: '75%',
        145: '80%',
        150: '85%',
        160: '90%',
        170: '95%',
        180: '100%',
      },
      fileList: [],
      // 点位状态
      switchStatus: false,
      switchStatusLoading: false,
      eidtMedia: null,
      statusForm: 1,
      // 资源使用情况弹框
      pointResUsageModal: false,
      modelType: [
        { text: 'QLG19-C215', value: '7' },
        { text: 'GWS19-49', value: '12' },
        { text: 'QLL19-C32', value: '13' },
        { text: 'QLG19-215', value: '14' },
        { text: 'QLL19-32', value: '15' },
        { text: 'QLG2020-R8', value: '17' },
      ],
      // //点位标签弹窗是否显示
      isPointTagModal: false,
      //标签管理弹窗id
      pointTagModalId: 0,
      //级联多选城市数据源
      citySourceArray: [],
      //级联多选标签数据源
      tagsTree: [],
    }
  },
  computed: {
    mediaListColumns() {
      // 表头
      const columns = [
        {
          title: '省份',
          key: 'province',
          dataIndex: 'province',
          align: 'left',
          width: 78,
          scopedSlots: {
            customRender: 'province',
          },
        },
        {
          title: '所属城市',
          key: 'city',
          dataIndex: 'city',
          align: 'left',
          width: 90,
          scopedSlots: {
            customRender: 'city',
          },
        },
        {
          title: '区/县',
          key: 'area',
          dataIndex: 'area',
          align: 'left',
          width: 78,
          scopedSlots: {
            customRender: 'area',
          },
        },
        {
          title: '标签数量',
          key: 'tagCnt',
          dataIndex: 'tagCnt',
          align: 'left',
          width: 90,
          scopedSlots: {
            customRender: 'tagCnt',
          },
        },
        {
          title: '网点资源',
          key: 'communityName',
          align: 'left',
          dataIndex: 'communityName',
          width: 150,
          scopedSlots: {
            customRender: 'communityName',
          },
        },
        {
          title: '点位名称',
          dataIndex: 'deviceName',
          align: 'left',
          key: 'deviceName',
          width: 150,
          scopedSlots: {
            customRender: 'deviceName',
          },
        },
        {
          title: 'MAC',
          key: 'MAC',
          dataIndex: 'MAC',
          align: 'left',
          width: 160,
          scopedSlots: {
            customRender: 'MAC',
          },
        },
        {
          title: '点位ID',
          key: 'pointId',
          dataIndex: 'pointId',
          align: 'right',
          width: 80,
        },
        {
          title: '媒体型号',
          dataIndex: 'TerminalType',
          key: 'TerminalType',
          align: 'left',
          width: 130,
          scopedSlots: {
            customRender: 'TerminalType',
          },
        },
        {
          title: '所属公司',
          align: 'left',
          key: 'companyName',
          dataIndex: 'companyName',
          width: 130,
          scopedSlots: {
            customRender: 'companyName',
          },
        },
        {
          title: '连续在线',
          align: 'left',
          key: 'onlineDayNum',
          dataIndex: 'onlineDayNum',
          width: 130,
          scopedSlots: {
            customRender: 'onlineDayNum',
          },
        },
        {
          title: '监播方式',
          align: 'left',
          key: 'watchModeName',
          dataIndex: 'watchModeName',
          width: 150,
          scopedSlots: {
            customRender: 'watchModeName',
          },
        },
        {
          title: '媒体来源',
          align: 'left',
          key: 'source',
          dataIndex: 'source',
          ellipsis: true,
        },
        {
          title: '媒体源状态',
          key: 'sourceStatus',
          dataIndex: 'sourceStatus',
          width: 130,
          filters: [
            { text: '正常', value: '2' },
            { text: '异常', value: '-1' },
          ],
          filteredValue: this.filteredSelect.sourceStatus || null,
          filterMultiple: false,
          scopedSlots: {
            customRender: 'sourceStatus',
          },
        },
        {
          title: '开放情况',
          key: 'publishStatus',
          dataIndex: 'publishStatus',
          width: 120,
          fixed: 'right',
          filters: [
            { text: '可接广告', value: '1' },
            { text: '不接广告', value: '0' },
          ],
          filteredValue: this.filteredSelect.publishStatus || null,
          filterMultiple: false,
          scopedSlots: {
            customRender: 'publishStatus',
          },
        },
        {
          title: '网络情况',
          key: 'mediaStatus',
          dataIndex: 'mediaStatus',
          scopedSlots: {
            customRender: 'mediaStatus',
          },
          width: 120,
          fixed: 'right',
          filters: [
            { text: '设备在线', value: '1' },
            { text: '设备离线', value: '0' },
            { text: '离线超时', value: '2' },
          ],
          filteredValue: this.filteredSelect.mediaStatus || null,
          filterMultiple: false,
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ]
      return columns
    },
  },
  methods: {
    changeCity(selectList) {
      this.filterParams.city = selectList
    },
    changetags(selectList) {
      this.filterParams.tagIds = selectList
    },
    //选中天数
    selectDate(v) {
      this.filterParams.thisDate = v
      // this.param.date = this.daysNumber.indexOf(this.thisDate)
    },
    testClose() {
      this.preBroadcast = false
    },
    // 设置点位状态
    switchStatusFun() {
      if (!this.eidtMedia.pointId) return
      this.switchStatusLoading = true
      // 0不可投，1可投
      api
        .postApiSpecil('/platform/point/updatePublishStatus', {
          pointId: this.eidtMedia.pointId,
          publishStatus: this.statusForm,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.msg)
            this.switchStatusLoading = false
            this.switchStatus = false
            this.getMediaList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
    },
    // 折叠搜索栏
    foldClick() {
      this.foldForm = !this.foldForm
    },
    columnsFilter(pagination, filters) {
      this.filteredSelect = filters
      for (let i in filters) {
        let value = filters[i] ? filters[i][0] : ''
        if (i === 'mediaStatus') {
          // 网络情况
          this.filterParams.devStatus = value
        } else if (i === 'sourceStatus') {
          // 媒体源状态
          this.filterParams.sourceStatus = value
        } else if (i === 'publishStatus') {
          // 点位状态
          this.filterParams.publishStatus = value
        }
      }
      this.getMediaList()
    },
    // 跳转到预播列表
    toReadyList() {
      this.$router.push('./readyPlayList')
    },
    // 查询
    handleSearch() {
      this.current = 1
      if (this.verifyCityCode()) {
        this.getMediaList()
      }
    },
    // 重置 - 初始化数据
    handleReset() {
      let obj = {
        city: [],
        deviceName: '',
        communityName: '',
        MAC: '',
        version: undefined,
        companyName: '',
        watchMode: [],
        devStatus: undefined,
        sourceStatus: undefined,
        publishStatus: undefined,
        thisDate: '0',
        tagIds: [],
        tagReverseFlag: 0,
      }
      this.filterParams = obj
      // 头部filter状态清空
      this.filteredSelect = {
        sourceStatus: [],
        publishStatus: [],
        mediaStatus: [],
      }
      // 分页
      this.current = 1
      this.getMediaList()
    },
    // 跳至
    changePage(page, pageSize) {
      // console.log(page, pageSize);
      this.pageSize = pageSize
      this.current = page
      this.getMediaList()
    },
    // 播放列表页码
    changePlayPage(current) {
      this.playPageNum = current
      this.getPlayList()
    },
    // 物料更新记录页码
    changeUpdatePage(current) {
      this.updatePageNum = current
      this.GetMaterialUpdateList()
    },
    // 资源使用情况页码
    changeResourceUsagePage(current) {
      this.adPageNum = current
      this.getResourceUsage()
    },
    // 广告列表页码
    changeAdPage(current) {
      this.adDayPageNum = current
      this.showOnedayPlayList()
    },
    onShowSizeChange(current, pageSize) {
      // console.log(current, pageSize)
      this.pageSize = pageSize
      this.getMediaList()
    },
    // 城市模糊筛选
    filterCity(value) {
      // console.log("value", value, this.filterParams.city);
    },
    // 列表操作
    handleRow(item, action) {
      this.pointId = action.pointId
      if (item.key == 1) {
        // 播放列表
        this.playListModal = true
        this.getPlayList(1)
      } else if (item.key == 2) {
        // 资源使用情况
        this.getResourceUsage()
        /* } else if (item.key == 3) {
        // 资源比例设置
        this.catPercentOfPoint(action.pointId); */
      } else if (item.key == 4) {
        // 物料更新记录
        this.materialUpdateModal = true
        this.GetMaterialUpdateList()
      } else if (item.key == 5) {
        // 设置点位状态
        this.eidtMedia = action
        this.statusForm = this.eidtMedia.publishStatus || 0
        this.switchStatus = true
        this.switchStatusLoading = false
      } else if (item.key == 6 && action.pointId !== undefined) {
        // 点位详情
        window.open(`/mediaDetail?pointId=${action.pointId}`)
      } else if (item.key == 7) {
        // 资源使用情况
        this.pointResUsageModal = true
      }
    },
    // 顶部更多按钮处下拉菜单点击事件
    handleMoreMenu(item) {
      if (item.key == 1) {
        // 预播设备
        this.toReadyList()
      } else if (item.key == 2) {
        // 变更日志
        this.getLogList()
      } else if (item.key == 3) {
        // 批量修改资源占比
        this.isMediaSourceModal = true
      } else if (item.key == 4) {
        // 广告预播点位
        this.preBroadcast = true
        this.preBroadcastParams = item
      } else if (item.key == 5) {
        // 查看导入（同步）点位记录
        this.updatePointModal = true
      } else if (item.key == 6) {
        //设置价格
        this.PriceVisible = true
      }
    },
    // 跳转详情
    goPlanDetail(row) {
      // console.log(row);
      sessionStorage.setItem('planId', row.planId)
      this.$router.push('/channelAdPlanDetail')
    },

    serializer: function (array, params) {
      const query = array.map((_) => `${params}=${_}`).join('&')
      return `${query}`
    },
    // 获取媒体列表
    getMediaList() {
      let params = {
        onlineDayNum:
          this.filterParams.thisDate == '不限'
            ? (this.filterParams.thisDate = 0)
            : this.filterParams.thisDate * 1, //在线天数
        pageNum: this.current,
        pageSize: this.pageSize,
        communityName: this.filterParams.communityName,
        areaCode: this.filterParams.city.length
          ? this.filterParams.city.map(Number).join()
          : '',
        tagIds: this.filterParams.tagIds.length
          ? this.filterParams.tagIds.map(Number).join()
          : '',
        mac: this.filterParams.MAC,
        deviceName: this.filterParams.deviceName,
        devStatus: this.filterParams.devStatus,
        companyName: this.filterParams.companyName,
        version: this.filterParams.version,
        watchMode: this.filterParams.watchMode.join(','),
        status: this.filterParams.sourceStatus,
        publishStatus: this.filterParams.publishStatus,
        tagReverseFlag: this.filterParams.tagReverseFlag ? true : '',
      }
      for (let i in params) {
        params[i] ? '' : delete params[i]
      }
      api.getApi('/machine/getMachineList', params).then((res) => {
        if (res.data.code == 200) {
          this.total = res.data.data.total
          let result = res.data.data.list
          this.mediaList = result.map((item, index) => {
            return {
              tagCnt: item.tagCnt || 0,
              key: index,
              pointId: item.pointId || '--',
              MAC: item.mac || '--',
              deviceName: item.deviceName || '--',
              TerminalType: item.version || '--',
              TerminalSystem: item.system || '--',
              province: item.province || '--',
              city: item.city || '--',
              area: item.area || '--',
              companyName: item.companyName || '--',
              communityName: item.communityName || '--',
              mediaStatus: item.devStatus,
              doorName: item.doorName || '--',
              watchModeName: (item.watchModeName || []).join(';'),
              source: item.source || '',
              sourceStatus: item.status,
              publishStatus: item.publishStatus,
              onlineDayNum: item.onlineDayNum + '天',
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 媒体列表导出流数据
    exportMediaExcel() {
      let params = {
        onlineDayNum:
          this.filterParams.thisDate == '不限'
            ? (this.filterParams.thisDate = 0)
            : this.filterParams.thisDate * 1, //在线天数
        communityName: this.filterParams.communityName,
        areaCode: this.filterParams.city.length
          ? String(this.filterParams.city[this.filterParams.city.length - 1])
          : '',
        mac: this.filterParams.MAC,
        deviceName: this.filterParams.deviceName,
        devStatus: this.filterParams.devStatus,
        companyName: this.filterParams.companyName,
        version: this.filterParams.version,
        watchMode: this.filterParams.watchMode.join(','),
        status: this.filterParams.sourceStatus,
        publishStatus: this.filterParams.publishStatus,
      }
      for (let i in params) {
        params[i] ? '' : delete params[i]
      }
      api.getApi_file('/machine/downloadMachineInfo', params).then((res) => {
        let time = timeFormat.toDateTime(new Date(), '').split(' ')
        let timeString = time[0] + time[1].split(':').join('')
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel;charset=utf-8',
        })
        if (navigator.msSaveBlob) {
          // 启用IE内置下载器下载
          try {
            window.navigator.msSaveBlob(blob, timeString + '媒体列表.xls')
          } catch (e) {
            console.log(e)
          }
        } else {
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) //创建下载的链接
          downloadElement.href = href
          downloadElement.download = timeString + '媒体列表.xls' //下载后文件名
          downloadElement.target = '_blank' // 针对 ie模式 的浏览器
          document.body.appendChild(downloadElement)
          downloadElement.click() //点击下载
          document.body.removeChild(downloadElement) //下载完成移除元素
          window.URL.revokeObjectURL(href) //释放掉blob对象
        }
      })
    },
    // 播放列表类型
    chooseAdType(e, type) {
      let cloumn = []
      if (e.target.value == 1) {
        cloumn = [
          {
            title: '计划名称',
            key: 'planName',
            scopedSlots: { customRender: 'planName' },
          },
          {
            title: '开始时间',
            dataIndex: 'beginTime',
            key: 'beginTime',
            width: 200,
          },
          {
            title: '结束时间',
            dataIndex: 'endTime',
            key: 'endTime',
            width: 200,
          },
          {
            title: '点位要求',
            key: 'pointDemand',
            scopedSlots: { customRender: 'pointDemand' },
          },
          {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ]
      } else {
        cloumn = [
          {
            title: '计划名称',
            key: 'planName',
            scopedSlots: { customRender: 'planName' },
          },
          {
            title: '开始时间',
            dataIndex: 'beginTime',
            key: 'beginTime',
            width: 200,
          },
          {
            title: '结束时间',
            dataIndex: 'endTime',
            key: 'endTime',
            width: 200,
          },
          {
            title: '广告时长',
            key: 'playDuration',
            scopedSlots: { customRender: 'playDuration' },
            width: 140,
          },
          {
            title: '标签',
            dataIndex: 'conditionText',
            key: 'conditionText',
            width: 140,
            ellipsis: true,
          },
          {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ]
      }
      if (type == 'play') {
        this.adType = e.target.value
        this.playColumns = cloumn
        this.getPlayList()
      } else {
        // 广告包切换
        this.packageList.type = e.target.value
        this.packageList.columns = cloumn
        if (e.target.value == 1) {
          this.packageList.list = this.packageList.accurate
        } else {
          this.packageList.list = this.packageList.shuffling
        }
      }
    },
    // 切换某天广告列表类型
    switchAdType(e, row) {
      // console.log(e.target.value,row);
      let cloumn = []
      if (e.target.value == 1) {
        cloumn = [
          {
            title: '计划名称',
            key: 'planName',
            scopedSlots: { customRender: 'planName' },
          },
          {
            title: '开始时间',
            dataIndex: 'beginTime',
            key: 'beginTime',
            width: 200,
          },
          {
            title: '结束时间',
            dataIndex: 'endTime',
            key: 'endTime',
            width: 200,
          },
          {
            title: '点位要求',
            key: 'pointDemand',
            scopedSlots: { customRender: 'pointDemand' },
          },
          {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ]
        this.adColumns = cloumn
        this.dayAdType = e.target.value
        this.showOnedayPlayList(row)
      } else {
        cloumn = [
          {
            title: '计划名称',
            key: 'planName',
            scopedSlots: { customRender: 'planName' },
          },
          {
            title: '开始时间',
            dataIndex: 'beginTime',
            key: 'beginTime',
            width: 200,
          },
          {
            title: '结束时间',
            dataIndex: 'endTime',
            key: 'endTime',
            width: 200,
          },
          {
            title: '广告时长',
            key: 'playDuration',
            scopedSlots: { customRender: 'playDuration' },
            width: 140,
          },
          {
            title: '标签',
            dataIndex: 'conditionText',
            key: 'conditionText',
          },
          {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ]
        this.adColumns = cloumn
        this.adList = []
        this.dayAdType = e.target.value
      }
    },
    // 查看物料
    showMaterial(item) {
      this.materialModal = true
      this.getMaterialDetail(item.materialId)
    },
    // 查看轮播广告物料
    showAdMaterial(item) {
      this.currentMaterialUrl = item.materialUrl
      this.adMaterialModal = true
    },
    handleCancel() {
      this.materialModal = false
      if (this.$refs.showMaterialVideo) {
        this.$refs.showMaterialVideo.pause()
      }
    },
    // 点击离线包
    showPackageList(item) {
      this.packageList.type = '1'
      this.packageModal = true
      this.packageList.title = item.packageVersion
      this.packageList.accurate = item.accurate
      this.packageList.shuffling = item.shuffling
      this.packageList.list = item.accurate
    },
    // 查看当前点位某日广告列表
    showOnedayPlayList(rowData) {
      let info = {
        pointId: rowData.pointId,
        date: rowData.date,
        pageSize: 5,
        pageNum: this.adDayPageNum,
      }
      api.getApi('/machine/getAdMachinePlayInfo', info).then((res) => {
        if (res.data.code == 200) {
          let resData = res.data.data.list || []
          this.adDayTotal = res.data.data.total
          let arr = []
          resData.forEach(function (item, index) {
            let obj = {
              key: index,
              planId: item.planId,
              planName: item.planName,
              beginTime: item.beginTime,
              endTime: item.endTime,
              playDuration: item.playDuration, //播放时长
              playTimes: item.playTimes || 0, //播放次数
              materialUrl:
                item.materialUrl ||
                'https://mfile.qinlinad.com/QADM/material/20200330/material-20200330-FIL-200330-16260067576.jpg',
            }
            arr.push(obj)
          })
          this.adList = arr
        } else {
          this.$message.error(res.data.msg)
        }
      })
      this.currentAdObj = rowData
      this.$set(
        this.currentAdObj,
        'currentDate',
        timeFormat.toDate2(rowData.date)
      )
      this.adListModal = true
    },
    // 获取播放列表
    getPlayList() {
      let info = {
        pointId: this.pointId,
        pageSize: 5,
        pageNum: this.playPageNum,
        priceStrategy: this.adType * 1,
      }
      api.getApi('/adPlan/getPlayList', info).then((res) => {
        if (res.data.code == 200) {
          this.playTotal = res.data.data.total
          let arr = []
          let result = res.data.data.list
          result.forEach(function (item, index) {
            let obj = {
              key: index,
              planId: item.planId,
              planName: item.planName,
              conditionText: item.conditionText,
              beginTime: timeFormat.toDateTime(item.beginTime),
              endTime: timeFormat.toDateTime(item.endTime),
              materialId: item.materialId,
              playDuration: item.playDuration,
              playTimes: item.playTimes,
            }
            arr.push(obj)
          })
          this.playList = arr
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 物料更新记录列表
    GetMaterialUpdateList() {
      let info = {
        pointId: this.pointId,
        pageSize: 5,
        pageNum: this.updatePageNum,
      }
      api.getApi('/package/getMaterialUpdateList', info).then((res) => {
        if (res.data.code == 200) {
          let arr = []
          let result = res.data.data
          this.updateTotal = result.total
          for (let data of result.list) {
            let obj = {
              packageVersion: data.packageName,
              updateTime: timeFormat.toDateTime(data.updateTime),
              type: data.packageType == 1 ? '离线包' : '在线包',
              accurate: [],
              shuffling: [],
            }
            for (let data2 of data.playRecordDetailList) {
              if (data2.priceStrategy == 1) {
                obj.accurate.push(data2)
              } else {
                obj.shuffling.push(data2)
              }
            }

            arr.push(obj)
          }
          this.materialList = arr
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取城市选择
    getCityList() {
      api.getApi('/machine/getAreaList').then((res) => {
        if (res.data.code == 200) {
          getCityListData(this.citySource, res.data.data)
          this.citySourceArray = [this.citySource]
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取物料详情
    getMaterialDetail(id) {
      api.getApi('/material/detail/' + id).then((res) => {
        if (res.data.code == 200) {
          this.materialInfo = res.data.data
          if (this.$refs.showMaterialVideo) {
            let video = this.$refs.showMaterialVideo
            video.play()
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 媒体变更日志
    getLogList() {
      let params = {
        pageNum: this.logPageInfo.current,
        pageSize: this.logPageInfo.pageSize,
      }
      api.getApi('/machine/log/list', params).then((res) => {
        if (res.data.code === 200) {
          let resData = res.data.data
          this.meidaLogList = resData.list.map((item) => {
            return {
              id: item.id,
              communityName: item.communityName,
              doorName: item.doorName,
              type: item.type,
              content: item.content || '--',
              createTime: item.createTime || '--',
              mediaName: item.communityName + '-' + item.doorName,
            }
          })
          this.logPageInfo.pageTotal = resData.total
          this.isMediaLogListModal = true
        } else {
          this.$message.warning(res.data.msg || '查看异常')
        }
      })
    },
    // 分页条数
    logOnShowSizeChange(current, pageSize) {
      this.logPageInfo.current = current
      this.logPageInfo.pageSize = pageSize
      this.getLogList()
    },
    // 页数
    logChangePage(page) {
      this.logPageInfo.current = page
      this.getLogList()
    },
    // 批量修改资源列表
    commitExecl() {
      // this.isMediaSourceModal = false
    },
    cancelCommitExecl() {
      this.isMediaSourceModal = false
    },
    // 上传文件前
    beforeUploadFun(file) {
      this.fileList = [...this.fileList, file]
      return false
    },
    // 控制上传文件数量
    handleChange(info) {
      if (this.fileList.length > 1) {
        this.fileList.shift()
      }
    },
    // 手动上传文件
    handleUpload() {
      const { fileList } = this
      if (fileList.length === 0) {
        this.$message.warning('您还没有上传文件哦~')
        return
      }
      const formData = new FormData()
      fileList.forEach((file) => {
        formData.append('file', file)
      })
      // this.uploading = true;
      api.postApi_file('/deviceShare/batchSave', formData).then((res) => {
        if (res.data.code == 200) {
          let resData = res.data.data
          this.isMediaSourceModal = false
          // 批量设置资源比例成功
          const h = this.$createElement
          this.$success({
            title: '批量设置资源比例成功',
            content: h('div', {}, [
              h('span', '已成功设置了 '),
              h(
                'span',
                { style: { color: '#1890FF' } },
                resData.successCount || '0'
              ),
              h('span', ' 个点位的资源比例，失败 '),
              h(
                'span',
                { style: { color: '#F5222D' } },
                resData.errorCount || '0'
              ),
              h('span', ' 个'),
              h(
                'a',
                {
                  on: {
                    click: () => {
                      // 下载上传失败的文件
                      let params = {
                        requestId: resData.requestId,
                      }
                      api
                        .getApi_file('/deviceShare/downloadErrorList', params)
                        .then((res) => {
                          let time = timeFormat
                            .toDateTime(new Date(), '')
                            .split(' ')
                          let timeString = time[0] + time[1].split(':').join('')
                          let blob = new Blob([res.data], {
                            type: 'application/vnd.ms-excel;charset=UTF-8',
                          })
                          if (navigator.msSaveBlob) {
                            // 启用IE内置下载器下载
                            try {
                              window.navigator.msSaveBlob(
                                blob,
                                timeString + '失败数据' + '.xls'
                              )
                            } catch (e) {
                              console.log(e)
                            }
                          } else {
                            let downloadElement = document.createElement('a')
                            let href = window.URL.createObjectURL(blob) //创建下载的链接
                            downloadElement.href = href
                            downloadElement.download =
                              timeString + '失败数据' + '.xls' //下载后文件名
                            downloadElement.target = '_blank' // 针对 ie模式 的浏览器
                            document.body.appendChild(downloadElement)
                            downloadElement.click() //点击下载
                            document.body.removeChild(downloadElement) //下载完成移除元素
                            window.URL.revokeObjectURL(href) //释放掉blob对象
                          }
                        })
                    },
                  },
                  style: {
                    position: 'absolute',
                    right: '122px',
                    bottom: '29px',
                    color: '#1890FF',
                  },
                },
                '下载失败数据'
              ),
            ]),
            onOk() {},
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //获取当前点位资源使用情况
    getResourceUsage() {
      let timeArr = timeFormat.getThirtyDaysLater()
      let params = {
        pointId: this.pointId, //459
        startDate: timeArr[0].replace(/[-\.]/g, '/'), // '2020/04/07'
        endDate: timeArr[1].replace(/[-\.]/g, '/'), // '2020/04/08'
        pageNum: this.adPageNum,
        pageSize: 5,
      }
      api.getApi('/deviceShare/getDayShare', params).then((res) => {
        if (res.data.code === 200) {
          this.adTotal = res.data.data.total
          let resData = res.data.data
          this.resourceUsageList = resData.list.map((item, index) => {
            let resObj = {
              key: index,
              date: item.date,
              useSeconds: item.useSeconds ? item.useSeconds : 0,
              totalSeconds: item.totalSeconds,
              pointId: item.pointId,
            }
            if (item.totalSeconds > 0) {
              resObj.usePercent = Math.floor(
                (resObj.useSeconds / resObj.totalSeconds) * 100
              )
            } else {
              resObj.usePercent = 0
            }
            return resObj
          })
          this.isUsageModal = true
        } else {
          this.$message.error(res.data.msg || '获取当前点位资源使用情况失败！')
        }
      })
    },
    //点位标签
    clickTagNum(record, index) {
      this.isPointTagModal = true
      this.pointTagModalId = record.pointId
    },
    //获取标签
    getTagsTree() {
      api.getApi('/tags/tree').then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data
          this.tagsTree = [res.data.data]
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    /**
     * .限制：
     a）省份：最多限制同时选择10个省份

     b）城市：最多限制同时选择10个城市

     c）区：最多限制同时选择15个区
     * 
     */
    verifyCityCode() {
      //省
      let provinceNum = 0
      //市
      let cityNum = 0
      // 区
      let countyNum = 0
      this.filterParams.city.forEach((code) => {
        if (this.isHaveCode(this.citySource, code, 1)) {
          provinceNum += 1
        } else if (this.isHaveCode(this.citySource, code, 2)) {
          cityNum += 1
        } else {
          countyNum += 1
        }
      })

      if (provinceNum > 10) {
        this.$message.warning('最多同时选择10个省份')
        return false
      }
      if (cityNum > 10) {
        this.$message.warning('最多同时选择10个城市')
        return false
      }
      if (countyNum > 15) {
        this.$message.warning('最多同时选择15个区')
        return false
      }
      return true
    },
    /**
     * data:遍历的数据源
     * code:需要查找的code
     * level:查找的层级
     */
    isHaveCode(data, code, level = 1) {
      switch (level) {
        case 1:
          return data.find((item) => {
            return item.value == code
          })
        case 2:
          return data.find((item) => {
            if (item.children && item.children.length > 0) {
              return this.isHaveCode(item.children, code, 1)
            }
          })
        default:
          break
      }
    },
  },
  created() {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  },
  mounted() {
    this.getCityList()
    this.getMediaList()
    this.getTagsTree()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@keyframes fadeIn {
  from {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
}
/deep/ .ant-table td {
  white-space: nowrap;
}
/deep/ .switch-status-modal {
  .ant-modal-header {
    padding: 10px 16px 12px;
  }
  .ant-modal-body {
    padding: 18px 16px;
  }
  .ant-modal-footer {
    border: none;
  }
}
.media-info-box {
  margin: 24px 32px 0;
  .media-info-content {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.65);
    .meida-box-num {
      color: #1890ff;
    }
    .meida-box-btn {
      margin: 0 0 0 auto;
      color: #1890ff;
      cursor: pointer;
    }
  }
}
.public-td {
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.readyplay_list {
  position: absolute;
  right: 32px;
  top: 120px;
  button {
    width: 88px;
  }
}

#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}
/deep/.ant-table-thead > tr,
/deep/ .ant-table-tbody > tr {
  height: 54px;
}

/deep/ .ant-table-thead > tr > th,
/deep/ .ant-table-tbody > tr > td {
  padding: 0px 16px !important;
}

.mediaList_table /deep/.ant-table-thead > tr,
.mediaList_table /deep/.ant-table-fixed-right .ant-table-thead > tr {
  height: 60px !important;
}

.mediaList_table /deep/.ant-table-tbody > tr,
.mediaList_table /deep/.ant-table-fixed-right .ant-table-tbody > tr {
  height: 52px !important;
}

.mediaList_table /deep/.ant-table-tbody > tr > td {
  line-height: 1;
}

.mediaLog_table /deep/ .ant-table-tbody > tr > td,
.mediaLog_table /deep/ .ant-table-thead > tr > th,
.resource-usage /deep/ .ant-table-tbody > tr > td,
.resource-usage /deep/ .ant-table-thead > tr > th {
  @extend .public-td;
}

.select-box {
  padding: 32px 32px 0;
  .form-label {
    width: 70px;
    min-width: 70px;
    text-align: right;
    white-space: nowrap;
  }
  .custom-form-row {
    flex-flow: row nowrap;
  }
  .custom-form-item {
    flex-grow: 1;
    animation: 1s fadeIn ease;
  }
  .fold-btn {
    font-size: 14px;
    line-height: 20px;
    color: #1890ff;
    cursor: pointer;
    .rotate-icon {
      transition: 0.8s ease;
    }
    .rotate-up {
      transform: rotate(-180deg);
    }
  }
}

.mediaList_table {
  padding: 16px 32px 32px;
  .column-nowrap {
    white-space: nowrap;
    i {
      color: #bfbfbf;
      transition: all 0.3s;
      margin-left: 8px;
    }
  }
}

.help-item {
  display: block;
  color: #fff;
  font-weight: 400;
  span:nth-child(2) {
    display: inline-block;
    width: 4rem;
    font-weight: 600;
  }
}

.bat-src {
  text-align: center;
  .load-text {
    display: block;
    margin-top: 16px;
  }
  .anticon svg {
    width: 48px;
    height: 48px;
  }
}

.mediaList_table .ant-form {
  max-width: none;
}

.mediaList_table .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.mediaList_table /deep/ .ant-dropdown-content {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  background: #fff;
  border-radius: 4px;
}

.mediaList_table
  /deep/
  .ant-table-fixed-right
  .ant-table-column-has-actions
  > span {
  margin-left: 10px;
}

.ant-col-8 .ant-input,
.ant-col-8 .ant-cascader-picker {
  width: calc(100% - 72px);
}

.img-mask img {
  width: 100%;
  height: 100%;
}

.img-mask video,
.video-box video {
  width: 100%;
}

.play-modal .radio-wrap {
  text-align: center;
  margin-bottom: 16px;
}

.page-wrap {
  float: unset;
  text-align: right;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}
.page-wrap span {
  margin-right: 5px;
}

.material-box {
  width: 264px;
  height: 500px;
  margin: 0 auto;
  background-size: 264px 500px !important;
  background: url('../../../public/images/material.png') no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 22px 4px 4px;
  position: relative;
}

.material-box .img-mask,
.material-box .video-mask {
  width: 222px;
  height: 160px;
  /*border: 1px solid #000;*/
  border-radius: 4px;
  cursor: pointer;
}

.material-box.half-screen-mask {
  margin: 0 auto;
  background-size: 264px 500px !important;
  background: url('../../../public/images/half-material.png') no-repeat;
}

.material-box.full-screen-mask .img-mask {
  height: 340px;
}

.material-box.full-screen-mask {
  margin: 0 auto;
  background-size: 264px 500px !important;
  background: url('../../../public/images/fullMaterial.png') no-repeat;
}

.material-box-wrap {
  display: flex;
  justify-content: space-around;
}

.img-mask {
  position: absolute;
  top: 20px;
  left: 21px;
}

.img-mask.video-mask {
  position: absolute;
  top: 182px;
  left: 21px;
}

.img-mask img {
  width: 100%;
  height: 100%;
}

.img-mask video,
.video-box video,
.upload-video video {
  width: 100%;
}

.mediaLog_table {
  max-height: 595px;
  min-height: 310px;
  overflow-y: auto;
}
.source-percent {
  display: flex;
  align-items: center;
  margin-top: 16px;
  .ant-select {
    flex-grow: 1;
  }
}
.myClassFlex {
  display: flex;
}

/deep/ .ponit—tag-modal {
  .ant-modal-header {
    padding: 10px 16px 12px;
  }
  .ant-modal-body {
    padding: 18px 16px;
  }
  .ant-modal-footer {
    border: none;
  }
}
</style>
